import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import BookingService from "../../../../services/bookingService";
import { ReceiveTicketForm } from "../../../../types/booking";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SvgClose } from "../../../../components/svg/SvgClose";
import { usePopupQuery } from "../../../../api/queries/popupQueries";

interface EditOrUpgradeModalProps {
  bookingId: string;
  productId: number;
  slug: string;
  productType?: string;
  isOpen?: boolean;
  productCanEdit?: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}

const EditOrUpgradeModal: React.FC<EditOrUpgradeModalProps> = ({
  productId,
  slug,
  bookingId,
  productType,
  isOpen,
  productCanEdit,
  onClose,
  onSubmit,
}) => {
  const popupQuery = usePopupQuery("GENERAL");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [receiveSuccess, setReceiveSuccess] = useState(false);

  const handleNavigate = ({
    isEdit = false,
    isUpgrade = false,
  }: {
    isEdit?: boolean;
    isUpgrade?: boolean;
  }) => {
    const urls = [
      { key: "TICKET", url: "/tickets/" },
      { key: "PASS", url: "/pass/" },
      { key: "TOUR", url: "/guide-tours/" },
      { key: "MUSICAL", url: "/musicals/" },
      { key: "SIM", url: "/e-sims/" },
    ];
    const url = urls.find((item) => item.key === productType)?.url;
    navigate(
      `${url}${slug}?editBookingId=${bookingId}${isEdit ? "&isEdit=true" : ""}${isUpgrade ? "&isUpgrade=true" : ""}`,
    );
  };

  // const {
  //   data,
  //   isLoading: queryIsLoading,
  //   refetch,
  //   error,
  // } = useQuery<ReceiveTicketForm | undefined, Error>(
  //   ["receiveTicketForm", productId],
  //   async () => {
  //     return (await BookingService.getReceiveInfo(
  //       bookingId,
  //       Number(productId),
  //     )) as ReceiveTicketForm;
  //   },
  //   {
  //     enabled: isOpen,
  //     onSuccess: (result) => {},
  //   },
  // );

  const handleOk = ({
    isEdit = false,
    isUpgrade = false,
  }: {
    isEdit?: boolean;
    isUpgrade?: boolean;
  }) => {
    setReceiveSuccess(false);
    handleNavigate({
      isEdit,
      isUpgrade,
    });
  };

  // useEffect(() => {
  //   if (isOpen) {
  //     refetch();
  //   }
  // }, [isOpen, productId, refetch]);

  // if (queryIsLoading) {
  //   return (
  //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  //       <div className="relative w-full max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
  //         <div className="p-6"></div>
  //       </div>
  //     </div>
  //   );
  // }

  // if (error) {
  //   return (
  //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  //       <div className="relative w-full max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
  //         <div className="p-6">
  //           {t("Error: ")}
  //           {error.message}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  const formatNewlineContent = (content: string) => {
    if (!content) return "";
    // Replace newlines with <br /> and return as JSX
    const parts = content.split("\n");
    return parts.map((part, idx) =>
      idx === 0 ? part : [<br key={idx} />, part],
    );
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[22.5rem] max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
            <button
              className="absolute right-0 top-0 m-4"
              type="button"
              onClick={onClose}
            >
              <SvgClose />
            </button>
            <div className="p-6 text-center">
              <img
                src="../../../../assets/images/icons/information.svg"
                className="mx-auto mb-6 h-12 w-12"
                alt=""
              />
              <h2 className="mb-2 text-[1.125rem] font-semibold leading-[1.6875rem] text-[#232323]">
                {t("Edit/Upgrade Guide")}
              </h2>
              {/* <p className="mb-6 text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]">
                <span className="font-semibold">{t("Modify:")}</span>{" "}
                {t(
                  "You can change to a different product within one year of purchase.",
                )}
              </p>
              <p className="mb-6 text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]">
                <span className="font-semibold">{t("Upgrade:")}</span>{" "}
                {t("You can add products by paying the price difference.")}
              </p> */}
              <p className="mb-6 text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]">
                {formatNewlineContent(
                  t(popupQuery.data?.contentConfirmUpgrade ?? ""),
                )}
              </p>
              <div className="flex justify-end gap-4 pt-6">
                <button
                  disabled={!productCanEdit}
                  onClick={() => handleOk({ isEdit: true })}
                  className="w-full rounded-[3.4375rem] border border-[#232323] py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323] hover:bg-gray-100"
                >
                  {t("Change")}
                </button>
                {productType === "PASS" && (
                  <button
                    onClick={() => handleOk({ isUpgrade: true })}
                    className={`w-full rounded-[3.4375rem] bg-primary py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323]`}
                  >
                    {t("Upgrade")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditOrUpgradeModal;
